// extracted by css-extract-rspack-plugin
var _1 = "NotificationButton-m_button-L1VB1YoQ";
export { _1 as "button" }
